import { CellValueChangedEvent, ColDef } from '@ag-grid-community/core';
import { DocLineUpdatedDto } from '@digiwall/goliath-documents/proxy';
import { Observable, of } from 'rxjs';
import { Rest } from '@abp/ng.core';
import { SupplierDeliveryNoteLinesEditorComponent } from '../supplier-delivery-note-lines-editor.component';
import { StockLinePolicy } from '../../../../stock-docs/stock-doc-movements/stock-doc-movement-detail/stock-doc-movement-lines/stock-doc-movement-lines-policies/stock-doc-movement-line.policy';

export class SupplierDeliveryNoteMovementPolicy implements StockLinePolicy {
  constructor(private ctx: SupplierDeliveryNoteLinesEditorComponent) {}

  get addPurchaseData() {
    return true;
  }

  enhanceColDefs(colDefs: ColDef[]): ColDef[] {
    this.ctx.markDimensionFieldsAsNonEditable(colDefs);
    return colDefs;
  }

  onCellValueChanged(event: CellValueChangedEvent): Observable<any> | boolean {
    switch (event.column.getColId()) {
      case 'unitPrice':
        return this.ctx.stockDocService.setLineUnitPrice(
          this.ctx.document.id,
          this.ctx.document.concurrencyStamp,
          event.data.id,
          event.data.unitPrice,
        );
      case 'articleStockUnitPrice':
        return this.ctx.stockDocService.setLineStockUnitPrice(
          this.ctx.document.id,
          this.ctx.document.concurrencyStamp,
          event.data.id,
          event.data.articleStockUnitPrice,
        );
      default:
        return true;
    }
  }

  beforeAddArticleLine(): Observable<DocLineUpdatedDto | null> {
    return of(null);
  }

  getAddArticleLineFn(): (
    docId: string,
    order: number,
    lineFromId: string,
    config?: Partial<Rest.Config>,
  ) => Observable<DocLineUpdatedDto> {
    return this.ctx.stockDocService.addArticleLine;
  }

  beforeSaveDoc(): Observable<DocLineUpdatedDto | null> {
    return of(null);
  }

  onLineAdded() {}

  beforeSaveLine(): void {}

  onUnsavedLineChanged(response: DocLineUpdatedDto): DocLineUpdatedDto {
    return response;
  }

  focusOnNewLine() {
    return true;
  }
}
